import Icon from '../components/Icon.vue'

Icon.register({
  signal: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M216 288H168C159.2 288 152 295.2 152 304V496C152 504.8 159.2 512 168 512H216C224.8 512 232 504.8 232 496V304C232 295.2 224.8 288 216 288zM88 384H40C31.2 384 24 391.2 24 400V496C24 504.8 31.2 512 40 512H88C96.8 512 104 504.8 104 496V400C104 391.2 96.8 384 88 384zM344 192H296C287.2 192 280 199.2 280 208V496C280 504.8 287.2 512 296 512H344C352.8 512 360 504.8 360 496V208C360 199.2 352.8 192 344 192zM472 96H424C415.2 96 408 103.2 408 112V496C408 504.8 415.2 512 424 512H472C480.8 512 488 504.8 488 496V112C488 103.2 480.8 96 472 96zM600 0H552C543.2 0 536 7.2 536 16V496C536 504.8 543.2 512 552 512H600C608.8 512 616 504.8 616 496V16C616 7.2 608.8 0 600 0z'
      }
    ]
  }
})
